import React, { useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { DefaultCheckbox } from 'services/UIUtils';
import DefaultButton from 'components/Utils/NewDefaultButton';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import './style.scss';
import { usePathParams } from 'components/Navigation/NavStack';
import { TenantMark } from 'components/Utils/LoadingScreen';
import TopBar from 'scenes/HomePatient2/TopBar';
import { useIsLoading } from 'careand-redux/slices/ui/hooks';
import Icon from 'components/Utils/NewIcon';

const QUESTIONNAIRE = [
  {
    label: 'q1',
    question: (
      <span>
        Do you have any of the following symptoms?
        <ul>
          <li>Fever</li>
          <li>Runny nose or nasal congestion</li>
          <li>Sore throat</li>
          <li>Cough</li>
          <li>Nausea, vomiting, or diarrhea</li>
          <li>New rashes</li>
        </ul>
      </span>
    ),
    required: true,
  },
];

export const STUDENT_CONSENT_TEXT =
  "Your healthcare provider has a Nurse Practitioner student working with them today. Your provider will supervise the student directly and remain fully involved in your care. Do you consent to the student's participation in your appointment?";

const InternQuestionnaire = {
  label: 'q_intern',
  question: <span>{STUDENT_CONSENT_TEXT}</span>,
  required: true,
};

const PatientQuestionnaire = () => {
  const dispatch = useAppDispatch();
  const { id, code, intern, telemedicine } = usePathParams();

  const [values, setValues] = useState({});
  const [success, setSuccess] = useState(false);

  const isLoading = useIsLoading(api.Appointments.submitPortalQuestionnaire);

  // Include intern question if intern parameter is present

  let questionnaire = [...QUESTIONNAIRE];
  if (telemedicine === 'true') {
    questionnaire = [];
  }
  if (intern === 'true') {
    questionnaire = [...questionnaire, InternQuestionnaire];
  }

  function onChange(name, value) {
    setValues({ ...values, [name]: value });
  }

  function questionToString(question) {
    let innerHtml = ReactDOMServer.renderToStaticMarkup(question);
    let string = innerHtml.split('<span>').join('');
    string = string.split('</span>').join('');
    string = string.split('<ul>').join('');
    string = string.split('</ul>').join('');
    string = string.split('<li>').join('\n-');
    string = string.split('</li>').join('');
    return string;
  }

  async function onSubmit() {
    let questions = questionnaire
      .map((question) => {
        return {
          question: questionToString(question.question),
          answer: values[question.label],
        };
      })
      .filter((d) => d.answer !== undefined)
      .map((d) => {
        return { ...d, answer: d.answer ? 'Yes' : 'No' };
      });

    const { isSuccess } = await dispatch(
      api.Appointments.submitPortalQuestionnaire({ id, code, questionnaire: { questions } }),
      { errorTitle: 'Questionnaire', meta: true },
    );

    if (isSuccess) {
      setSuccess(isSuccess);
    }
  }

  function isButtonDisabled() {
    let disabled = false;

    questionnaire
      .filter((question) => !!question.required)
      .forEach((question) => {
        if (values[question.label] === undefined) disabled = true;
      });

    return disabled;
  }

  let title = 'Symptom Screener';

  if (telemedicine) title = 'NP Student Consent Form';

  return (
    <div className="questionnaire-screen page">
      <TopBar title={title} hideBack={true} />
      <div className="page-content">
        {success && (
          <div className="success-message">
            <Icon src="circle-check" className="blue" width="75px" />
            <span>Your symptom screener has been successfully submitted. Thank you!</span>
          </div>
        )}
        {!success && (
          <>
            <TenantMark variant="color" noRepeat={true} />
            {questionnaire.map((question) => (
              <div className="question" key={question.label}>
                <div className="q">{question.question}</div>
                <div className="a">
                  <Checkbox
                    name={question.label}
                    values={values}
                    onChange={onChange}
                    setValue={true}
                  />
                  <Checkbox
                    name={question.label}
                    values={values}
                    onChange={onChange}
                    setValue={false}
                  />
                </div>
              </div>
            ))}
            <DefaultButton
              name="Submit"
              onClick={onSubmit}
              disabled={isButtonDisabled()}
              loading={isLoading}
            />
          </>
        )}
      </div>
    </div>
  );
};

const Checkbox = ({ name, values, onChange, setValue }) => (
  <DefaultCheckbox
    name={name}
    value={values[name] === setValue}
    onChange={() =>
      onChange(name, values[name] !== undefined && values[name] === setValue ? undefined : setValue)
    }
    style={{ display: 'inline-block' }}
    text={setValue ? 'Yes' : 'No'}
  />
);

export default PatientQuestionnaire;
